import { App } from 'vue';

/**
 * Analytics plugin to provide compatibility with vue-analytics API
 * This wraps vue-gtag to provide the same interface as the old $ga API
 */
export interface AnalyticsPlugin {
  event(category: string, action: string, label?: string, value?: number): void;
  disable(): void;
  enable(): void;
}

class Analytics implements AnalyticsPlugin {
  /**
   * Track an event
   * @param category - Event category (e.g., 'video', 'folder', 'settings')
   * @param action - Event action (e.g., 'play', 'open', 'language')
   * @param label - Event label (optional)
   * @param value - Event value (optional)
   */
  event(category: string, action: string, label?: string, value?: number): void {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value
      });
    }
  }

  /**
   * Disable analytics tracking
   */
  disable(): void {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  }

  /**
   * Enable analytics tracking
   */
  enable(): void {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  }
}

const analytics = new Analytics();

export default {
  install(app: App) {
    // Make $ga available in all components
    app.config.globalProperties.$ga = analytics;
  }
};

// Export for use in composition API
export const useAnalytics = (): AnalyticsPlugin => analytics;

